module.exports = "bootstrap-multiselect";